import { C } from "../lib/colors.js";
import { branchEngineConfirmText } from "../lib/forecast/branchEngineConfirm.js";
import { ModalShell } from "./Panels.jsx";
import { Button } from "./ui/Primitives.jsx";
import { ui } from "../lib/telemetry/instrument.js";

/**
 * Confirm-before-spend modal for a scenario that inherits a deep-lane engine the picker did
 * not select. Pure props: the question in, one of two answers out. A backdrop click cancels
 * (ModalShell's onClose), like the delete-forecast confirm it is styled after.
 */
export function BranchEngineConfirmModal({ inheritedEngine, pickerEngine, onConfirm, onCancel }) {
  return (
    <ModalShell
      surface="branch-engine-confirm"
      onClose={onCancel}
      zIndex={600}
      panelStyle={{
        background: C.panel,
        border: `1px solid ${C.border}`,
        borderRadius: 12,
        padding: 24,
        width: 420,
        maxWidth: "92vw",
        boxShadow: C.shadowBox,
      }}
    >
      <div style={{ fontSize: 15, fontWeight: 600, color: C.white, marginBottom: 8 }}>
        Run this scenario?
      </div>
      <div style={{ fontSize: 13, color: C.grayL, lineHeight: 1.5, marginBottom: 24 }}>
        {branchEngineConfirmText(inheritedEngine, pickerEngine)}
      </div>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <Button {...ui("branch-engine-confirm.cancel")} data-popup-cancel onClick={onCancel}>
          Cancel
        </Button>
        <Button
          {...ui("branch-engine-confirm.continue")}
          data-popup-primary
          variant="primary"
          onClick={onConfirm}
        >
          Run scenario
        </Button>
      </div>
    </ModalShell>
  );
}
